import axios, {AxiosResponse} from 'axios'
import {ID} from '../../../../_metronic/helpers'
import {GetDashboardResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const DASHBOARD_URL = `${API_URL}/dashboard`

const listDashboards = (
  dataInicial: string = '2023-10-01',
  dataFinal: string = '2023-12-21'
): Promise<GetDashboardResponse> => {
  const params = {dataInicial, dataFinal}

  return axios
    .get(`${DASHBOARD_URL}`, {params})
    .then((d: AxiosResponse<GetDashboardResponse>) => d.data)
}

export {listDashboards}
